<script>
    import Page from '../../Page/v1/Page.svelte';

    /** @type {'full'|'wide'|'narrow'} */
    export let contentAreaLayout = 'wide';

    /** @type {'left'|'right'} */
    export let sidebarPosition = 'left';
</script>

<Page {contentAreaLayout}>
    <div class="two-column-area"
        class:two-column-area--sidebar-left={sidebarPosition === 'left'}
        class:two-column-area--sidebar-right={sidebarPosition === 'right'}>

        {#if sidebarPosition === 'left'}
            <slot name="sidebar" />
            <slot name="content" />
        {:else}
            <slot name="content" />
            <slot name="sidebar" />
        {/if}
    </div>
</Page>